import React from "react";
import { Toaster } from './components/ui/sonner';
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Aggressive suppression of ResizeObserver errors
// This is a known cosmetic issue with Radix UI and doesn't affect functionality

// Method 1: Intercept all console errors
const originalConsoleError = console.error;
console.error = function(...args) {
  const firstArg = args[0];
  if (
    typeof firstArg === 'string' && 
    (firstArg.includes('ResizeObserver') || 
     firstArg.includes('loop limit exceeded') ||
     firstArg.includes('loop completed'))
  ) {
    return;
  }
  originalConsoleError.apply(console, args);
};

// Method 2: Override ResizeObserver entirely
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (e) {
          // Silently catch ResizeObserver errors
          if (!e.message.includes('ResizeObserver')) {
            throw e;
          }
        }
      });
    });
  }
};

// Method 3: Global error handler
window.addEventListener('error', (event) => {
  if (
    event.message && 
    (event.message.includes('ResizeObserver') ||
     event.message.includes('loop limit exceeded') ||
     event.message.includes('loop completed'))
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return false;
  }
}, true);

// Method 4: Unhandled rejection handler
window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason && 
    event.reason.message &&
    (event.reason.message.includes('ResizeObserver') ||
     event.reason.message.includes('loop limit exceeded') ||
     event.reason.message.includes('loop completed'))
  ) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
    <Toaster position="top-right" />
  </>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
